import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fifteenseateracminiluxury() {



    const cardData =
    {
        keyword: '15 Seater AC Mini Luxury Bus On Rent Pune',
        heading: 'Urbania on rent in pune: 15 Seater AC Mini Luxury Bus On Rent Pune',
        headingDescription: 'Urbania On Rent in Pune offers premium and dependable 15 Seater AC Mini Luxury Bus On Rent Pune services for corporate groups, families, tourists, and event travelers seeking comfortable and stylish group transportation across the city and nearby destinations. Our well-maintained 15-seater luxury AC mini bus fleet provides spacious seating, powerful air-conditioning, plush interiors, and smooth performance, making it ideal for airport transfers, corporate outings, weddings, sightseeing tours, local travel, and outstation journeys from Pune. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for 15-seater AC mini luxury bus hire in.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s most iconic historical landmark, built in 1732 by Peshwa Bajirao I as the seat of Maratha power. Known for its massive stone walls, grand gates like Delhi Darwaza, and spacious courtyards, the fort reflects the glory of the Peshwa era. Though a fire destroyed much of the structure, its ruins still narrate stories of bravery, politics, and royal life. The evening light and sound show vividly brings Maratha history to life, making it a must-visit heritage attraction."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a majestic monument deeply connected to India’s freedom struggle. Built in 1892, it served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. The palace now functions as a memorial and museum showcasing personal belongings, photographs, and letters of Gandhiji. Surrounded by lush lawns and Italian-style arches, it offers a peaceful and historically enriching experience."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort stands atop a hill in the Sahyadri range and is famous for the legendary battle fought by Tanaji Malusare for Chhatrapati Shivaji Maharaj. The fort offers breathtaking views of valleys, dams, and surrounding mountains. Popular among trekkers, history lovers, and nature enthusiasts, Sinhagad also offers local Maharashtrian food like pithla-bhakri at the top. It perfectly combines adventure, history, and scenic beauty."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark dedicated to Lord Ganesha. The beautifully adorned idol attracts thousands of devotees daily and lakhs during Ganesh Chaturthi. The temple trust is also known for its social and charitable work. The festive atmosphere, devotion, and cultural significance make it the spiritual heart of Pune."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of the oldest heritage sites in Pune, offering panoramic views of the entire city. After climbing 103 stone steps, visitors reach the Parvati Temple complex built during the Peshwa period. The hill also houses a small museum and several ancient shrines. Sunrise and sunset views from Parvati Hill are especially popular among photographers and peace seekers."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. Located in the heart of the city, it provides a calm and spiritual escape from urban chaos. The temple features monolithic pillars, a Nandi mandap, and ancient carvings showcasing early Indian craftsmanship. It is a hidden heritage gem of Pune."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a cultural treasure trove displaying over 20,000 artifacts collected from across India. The museum showcases traditional utensils, musical instruments, sculptures, weapons, paintings, and everyday objects from ancient Indian households. The recreated Mastani Mahal is a major highlight. It offers deep insight into India’s artistic and cultural heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a globally renowned center for meditation, mindfulness, and wellness. Spread across serene gardens, it attracts visitors from all over the world seeking inner peace and relaxation. The resort offers meditation sessions, therapies, and spiritual programs in a calm and luxurious environment."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. It features flowing water streams, arched bridges, manicured lawns, and seasonal flowers. Ideal for families, couples, and photographers, the garden offers a peaceful escape amidst greenery and beautifully designed landscapes."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular leisure spot located on the outskirts of Pune. The vast water reservoir, surrounding hills, and cool breezes make it especially attractive during monsoon and evenings. Visitors enjoy scenic views, street food stalls, and relaxed outings with friends and family. It also serves as the gateway to Sinhagad Fort."
  },
  {
    "title": "Vetal Tekdi",
    "description": "Vetal Tekdi is Pune’s highest hill and a green paradise within the city limits. Known for morning walks, cycling, and bird watching, it offers beautiful views of Pune’s skyline and surrounding hills. The quiet environment and fresh air make it a favorite spot for fitness enthusiasts and nature lovers."
  },
  {
    "title": "Bund Garden",
    "description": "Bund Garden is a scenic riverside garden located near the Mula-Mutha River. It is a popular spot for evening walks, jogging, and relaxation. The well-maintained lawns, flower beds, and calm atmosphere make it ideal for families and couples. Boat Club Road nearby adds to its charm."
  }
],






"services": [
{
"name": "15 Seater AC Mini Luxury Bus on Rent Pune",
"description": "15 Seater AC Mini Luxury Bus on Rent Pune offers premium air-conditioned mini buses for comfortable local and outstation travel. Ideal for families, corporate groups, and small tour parties, these buses feature plush seating, modern interiors, and professional chauffeurs for a smooth and enjoyable journey."
},
{
"name": "15 Seater Mini Bus Hire Pune",
"description": "15 Seater Mini Bus Hire Pune provides convenient rental options for city travel, sightseeing, and small group tours. Ensures safety, comfort, and timely travel for corporate groups, families, and tourists seeking a hassle-free experience."
},
{
"name": "AC Mini Luxury Bus Pune",
"description": "AC Mini Luxury Bus Pune delivers a premium travel experience with fully air-conditioned interiors, ergonomic seating, and ample legroom. Suitable for executive travel, leisure trips, and long-distance journeys across Pune and surrounding areas."
},
{
"name": "Corporate 15 Seater Bus Hire Pune",
"description": "Corporate 15 Seater Bus Hire Pune provides professional transport solutions for office outings, team trips, and client visits. Features include punctual service, executive-level seating, and trained chauffeurs for seamless corporate travel."
},
{
"name": "15 Seater Bus for Wedding Pune",
"description": "15 Seater Bus for Wedding Pune offers spacious and stylish mini buses for transporting wedding guests. Ensures comfort, timely arrival, and a luxurious experience for weddings and related events."
},
{
"name": "15 Seater Outstation Bus Pune",
"description": "15 Seater Outstation Bus Pune provides AC and non-AC mini buses for long-distance travel, weekend getaways, and sightseeing tours. Features comfortable seating, luggage support, and experienced drivers for a safe and smooth journey."
},
{
"name": "15 Seater Airport Transfer Bus Pune",
"description": "15 Seater Airport Transfer Bus Pune offers timely pick-up and drop services to and from Pune Airport. Ideal for families, corporate travelers, and tourists seeking reliable, stress-free, and comfortable airport transport."
},
{
"name": "Luxury Mini Bus 15 Seater Pune",
"description": "Luxury Mini Bus 15 Seater Pune provides high-end mini buses with plush seating, modern interiors, and professional drivers. Perfect for VIP travel, family trips, and corporate outings seeking elegance and comfort."
},
{
"name": "Affordable 15 Seater Bus Hire Pune",
"description": "Affordable 15 Seater Bus Hire Pune offers budget-friendly rental options without compromising on comfort, safety, or convenience. Suitable for small group travel, local sightseeing, and short trips around Pune."
},
{
"name": "Chauffeur Driven 15 Seater Bus Pune",
"description": "Chauffeur Driven 15 Seater Bus Pune ensures a stress-free journey with verified, experienced drivers. Ideal for families, corporate groups, and tourists looking for safe, reliable, and professional travel."
},
{
"name": "15 Seater Group Travel Bus Pune",
"description": "15 Seater Group Travel Bus Pune provides comfortable and spacious mini buses for friends, families, and corporate groups. Ensures safe, convenient, and enjoyable travel for group outings, excursions, and tours."
},
{
"name": "Best 15 Seater Mini Bus Rental Pune",
"description": "Best 15 Seater Mini Bus Rental Pune offers top-quality mini buses with excellent service, punctual pick-ups, and comfortable travel experience for both local and outstation trips."
},
{
"name": "15 Seater Picnic Bus Pune",
"description": "15 Seater Picnic Bus Pune delivers reliable and spacious mini buses for family picnics, school outings, and group excursions. Features include comfortable seating, luggage support, and professional drivers for a smooth trip."
},
{
"name": "Reliable 15 Seater Bus Service Pune",
"description": "Reliable 15 Seater Bus Service Pune offers dependable and punctual mini bus services for city and outstation travel. Known for safety, comfort, and professional drivers, making group travel seamless and enjoyable."
},
{
"name": "Executive 15 Seater Bus Pune",
"description": "Executive 15 Seater Bus Pune caters to VIPs, corporate executives, and business travelers. Features luxurious interiors, privacy, and professional chauffeurs for a premium travel experience with comfort and style."
}
],
"tableData": [
["15 Seater AC Mini Luxury Bus on Rent Pune", "15 Seater Mini Bus Hire Pune"],
["AC Mini Luxury Bus Pune", "Corporate 15 Seater Bus Hire Pune"],
["15 Seater Bus for Wedding Pune", "15 Seater Outstation Bus Pune"],
["15 Seater Airport Transfer Bus Pune", "Luxury Mini Bus 15 Seater Pune"],
["Affordable 15 Seater Bus Hire Pune", "Chauffeur Driven 15 Seater Bus Pune"],
["15 Seater Group Travel Bus Pune", "Best 15 Seater Mini Bus Rental Pune"],
["15 Seater Picnic Bus Pune", "Reliable 15 Seater Bus Service Pune"],
["Executive 15 Seater Bus Pune", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "15 Seater AC Mini Luxury Bus On Rent Pune",
        "WhyChoosedescription": "15 Seater AC Mini Luxury Bus On Rent Pune is perfect for small group travel, family outings, corporate trips, and city or outstation journeys, offering comfort and luxury."
    },
    {
        "WhyChooseheading": "Spacious and Well-Equipped Luxury Mini Buses",
        "WhyChoosedescription": "Our 15 Seater AC Mini Luxury Buses come with air-conditioning, ample legroom, reclining seats, and premium interiors for a comfortable and stylish travel experience."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "All buses are driven by trained and licensed drivers familiar with Pune and nearby routes, ensuring safe, timely, and hassle-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "15 Seater AC Mini Luxury Bus On Rent Pune offers competitive rates with no hidden charges, making luxury travel budget-friendly for small groups."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "We provide round-the-clock booking assistance and support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Our luxury mini buses are available for hourly rentals, full-day bookings, multi-day trips, corporate travel, sightseeing tours, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "We guarantee on-time pickups and dependable service, ensuring smooth and stress-free travel experiences in Pune and nearby regions."
    }
]
}

const faqData = [
    {
        question: 'Is 15 Seater AC Mini Luxury Bus On Rent Pune available for local and outstation travel?',
        answer: 'Yes, our luxury mini bus can be booked for city travel, corporate trips, family outings, and short to medium-distance journeys.',
    },
    {
        question: 'How can I book the 15 Seater AC Mini Luxury Bus On Rent Pune?',
        answer: 'You can book via phone, WhatsApp, or online for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose 15 Seater AC Mini Luxury Bus On Rent Pune?',
        answer: 'It offers luxury seating, professional drivers, clean vehicles, transparent pricing, and flexible packages for corporate, family, and group travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers are licensed, trained, and experienced in handling 15 Seater AC Mini Luxury Buses safely.',
    },
    {
        question: 'Can pickup and drop-off locations be customized?',
        answer: 'Absolutely. Flexible pickup and drop locations are allowed across Pune and nearby areas.',
    },
    {
        question: 'Is 15 Seater AC Mini Luxury Bus On Rent Pune available 24x7?',
        answer: 'Yes, bookings and customer support are available 24x7 for your convenience.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are regularly sanitized, cleaned, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout your journey for smooth and stress-free travel.',
    },
    {
        question: 'Can this bus be used for corporate, family, and group trips?',
        answer: 'Yes, the 15 Seater AC Mini Luxury Bus is ideal for corporate outings, family trips, and small group travel.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Abhijit Patil',
        feedback: 'The 15 Seater AC Mini Luxury Bus provided a very comfortable and luxurious ride for our corporate trip. Highly recommended!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Deshmukh',
        feedback: 'We booked this luxury mini bus for a family outing. Spacious, clean, and excellent service from start to finish.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Rakesh Kulkarni',
        feedback: 'Our group travel in Pune was hassle-free thanks to the 15 Seater AC Mini Luxury Bus. Punctual and reliable service.',
        rating: 5,
    },
];


































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "15 Seater AC Mini Luxury Bus On Rent Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/15-seater-mini-bus-pune.jpg",
  "description": "15 Seater AC Mini Luxury Bus On Rent in Pune offers premium AC mini buses for corporate travel, weddings, outstation trips, airport transfers, picnics, and group travel. Chauffeur-driven 15-seater mini buses ensure safe, comfortable, and luxury transportation across Pune and nearby destinations.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/15-seater-ac-mini-luxury-bus-on-rent-pune"
  }
};





    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | 15 Seater AC Mini Luxury Bus On Rent Pune | Premium Mini Bus Hire 
  </title>

  <meta
    name="description"
    content="Book 15 Seater AC Mini Luxury Bus On Rent in Pune for corporate travel, weddings, airport transfers, outstation trips, picnics, and group travel. Chauffeur-driven 15-seater mini buses provide safe, comfortable, and luxury transportation in Pune."
  />

  <meta
    name="keywords"
    content="15 Seater AC Mini Luxury Bus on Rent Pune, 15 Seater Mini Bus Hire Pune, AC Mini Luxury Bus Pune, Corporate 15 Seater Bus Hire Pune, 15 Seater Bus for Wedding Pune, 15 Seater Outstation Bus Pune, 15 Seater Airport Transfer Bus Pune, Luxury Mini Bus 15 Seater Pune, Affordable 15 Seater Bus Hire Pune, Chauffeur Driven 15 Seater Bus Pune, 15 Seater Group Travel Bus Pune, Best 15 Seater Mini Bus Rental Pune, 15 Seater Picnic Bus Pune, Reliable 15 Seater Bus Service Pune, Executive 15 Seater Bus Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/78.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Fifteenseateracminiluxury;